var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = typeof props.onClick === "function" ? props.onClick.bind(props.context) : _this.noop;
        _this.element = React.createRef();
        _this.focus = props.focus ? true : false;
        _this.timeout = null;
        return _this;
    }
    Button.prototype.setFocus = function () {
        if (this.element.current !== null) {
            this.element.current.focus();
        }
    };
    Button.prototype.componentDidMount = function () {
        if (this.focus === true) {
            this.timeout = setTimeout(this.setFocus.bind(this), 10);
        }
    };
    Button.prototype.noop = function () { };
    Button.prototype.render = function () {
        return (React.createElement("button", { type: "button", className: "rj-popup-message__button " + (this.props.classes || ""), ref: this.element, onClick: this.onClick, "data-uat": this.props.uat }, this.props.text));
    };
    return Button;
}(React.Component));
export { Button };
//# sourceMappingURL=Button.js.map